import { useLayoutEffect, useRef, useState } from "react";
import { Card, Text, Title, Divider, Box } from "@mantine/core";
import _ from "lodash";
import { FormSectionCard } from "../layout/page";
import { useTranslation } from "react-i18next";
const K_SECTION_MIN_HEIGHT = "350px";

const sectionHasVisibleContent = (node) => {
  if (!node) return false;
  const text = (node.innerText || node.textContent || "").trim();
  if (text) return true;
  return Boolean(
    node.querySelector(
      "button, a, input, textarea, select, img, canvas, [role='button']"
    )
  );
};

const FormSection = ({
  title,
  titleOrder = 5,
  description,
  children,
  radius = "sm",
  p = "xs",
  withBorder = true,
  withPaper = true,
  minHeight = K_SECTION_MIN_HEIGHT,
  collapseWhenEmpty = false,

  ...props
}) => {
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(() => collapseWhenEmpty);

  useLayoutEffect(() => {
    if (!collapseWhenEmpty) return;
    setIsEmpty(!sectionHasVisibleContent(contentRef.current));
  }, [collapseWhenEmpty, children]);

  const content = collapseWhenEmpty ? (
    <div ref={contentRef} hidden={isEmpty}>
      {children}
    </div>
  ) : (
    children
  );

  if (collapseWhenEmpty && isEmpty) return content;

  return (
    <>
      {/* {JSON.stringify(props)} */}

      <FormSectionCard
        title={title}
        description={description}
        mt={"md"}
        withPaper={withPaper}
        {...props}
      >
        {content}
      </FormSectionCard>
      {/* <Card
                withBorder={withBorder}
                p={p}
                radius={radius}
                {...props}
                style={{ minHeight }}
            >
                {title && (
                    <Box mb={20}>
                        {<Title order={titleOrder}>{title}</Title>}

                        {description && (
                            <Text size="xs" color="dimmed" mt={3} mb="xl">
                                {description}
                            </Text>
                        )}
                    </Box>
                )}

                {children}
            </Card> */}
    </>
  );
};

export default FormSection;
